import { Box, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { API_DELETE, API_GET, DBRequest, useConfig } from '../../../api/api';
import useFetch from '../../../api/useFetch';
import DateTimeLabel from '../../label/DateTimeLabel';
import MoneyLabel from '../../label/MoneyLabel';
import ExoTable from '../ExoTable';
import DeleteIcon from '@mui/icons-material/Delete';

const WorkHourEstimatorSelector = ({ onSelect }) => {
  const { t } = useTranslation();
  const config = useConfig();

  const { apiData, setApiData } = useFetch('wage-calculations');

  const columns = [
    {
      header: t('Title'), // header of column
      key: 'title', // key of column in row-object
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      sortable: true, // enable sort function for column
      onClick: (row) => handleSelect(row),
    },
    {
      header: t('Total Costs'),
      key: 'totalCost',
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      //width: "270px",
      sortable: true, // enable sort function for column
      //hiddenMobile: true,
      cell: ({ row }) => (
        <Typography className=" monospace">
          <MoneyLabel money={row.totalCost} />
        </Typography>
      ),
      onClick: (row) => handleSelect(row),
    },
    {
      header: t('Last Change'),
      key: 'updatedAt',
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      //width: "270px",
      sortable: true, // enable sort function for column
      //hiddenMobile: true,
      cell: ({ row }) => (
        <Typography className=" monospace">
          <DateTimeLabel dateTime={row.updatedAt} />
        </Typography>
      ),
      onClick: (row) => handleSelect(row),
    },
    {
      header: t('Delete'),
      key: 'delete',
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      width: '100px',
      sortable: true, // enable sort function for column
      //hiddenMobile: true,
      cell: ({ row }) => (
        <IconButton onClick={() => handleDelete(row)}>
          <DeleteIcon />
        </IconButton>
      ),
      //onClick: (row) => handleSelect(row),
    },
  ];

  function handleDelete(row) {
    DBRequest({
      config,
      path: `wage-calculations/${row.id}`,
      method: API_DELETE(),
      onResponse: () => handleApiRemove(row),
    });
  }

  function handleApiRemove(row) {
    const newApiData = apiData.data.filter((el) => el.id != row.id);
    setApiData({ data: newApiData });
  }

  function handleSelect(row) {
    {
      /*DBRequest({
      config,
      path: `wage-calculations/${row.id}`,
      method: API_GET,
      onResponse: onSelect,
    });*/
    }
    onSelect(row);
  }

  return (
    <Box className="px-5">
      <Typography className="py-5" variant="h3">
        {t('Load time calculation')}
      </Typography>
      <ExoTable data={apiData} columns={columns} />
    </Box>
  );
};

export default WorkHourEstimatorSelector;
